import React from "react";

const TopCoinUkPolicy = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Effective Date: 10/08/2025
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Company: TopCoin UK. Ltd
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-0">
              Company Registeration No: 16483297
            </p>
            <p className="text-dark fw-semibold opacity-50 mb-3">
              Contact: info@topcoinuk.com
            </p>
            <h5 className="text-dark opacity-75">Issued by: Topcoin UK Ltd.</h5>
            <h6 className="text-dark opacity-75">1. Purpose and Scope</h6>
            <p className="text-dark opacity-50">
              This policy governs the global operations of Topcoin UK (TCUK), a
              customer rewards and business advertising system. As TCUK expands
              internationally, this policy ensures that all customers,
              businesses, and partners understand the purpose, structure, and
              operational framework of TCUK in every region.
            </p>
            <div>
              <h6 className="text-dark opacity-75">
                2. TCUK Global Operating Principles
              </h6>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Topcoin UK is not a cryptocurrency, investment scheme, or
                  gambling platform.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  The system is designed to reward customers with free TopCoin
                  when they make purchases at participating businesses.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  These TopCoins unlock structured loyalty milestones, which may
                  include company-funded reward releases, encouraging continued
                  engagement and brand loyalty.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TCUK works globally using local partnerships, while the
                  central reward allocation system remains managed and
                  standardized by Topcoin UK Ltd (UK HQ).
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                3. TCUK System (Global Version)
              </h6>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Customers receive free TCUK with every eligible purchase.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoins are stored in eight TopCoin Wallets. As more TopCoins
                  accumulate, wallets unlock in sequence.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  With progress, customers also unlock eight rewards Wallets,
                  each tied to a Topcoin UK Coin.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  The 8th and final Coin is known as the Eternity TopCoin,
                  linked to the Eternity Cash Wallet, representing the ultimate
                  loyalty milestone.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoins are not tradable, not purchasable, and do not act as
                  currency or financial products. They measure engagement and
                  loyalty only.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All coins, including the Eternity Coin, must be earned through
                  activity within the TCUK ecosystem.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                4. Business Participation Policy
              </h6>
              <p className="mb-1 text-dark opacity-50 fw-semibold ps-3">
                Requirements for Global Businesses:
              </p>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Must register and agree to the TCUK Business Agreement.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Pay a TopCoin issuance fee for every TopCoin given to
                  customers (based on the internal TopCoin rate).
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Receive marketing, listing on the TCUK global blockchain
                  network, and receive marketing benefits and promotional
                  credits from network-wide activity.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Businesses in each country have local blockchain branches, but
                  remain connected to the global Topcoin UK blockchain.
                </li>
              </ul>
            </div>
            <div>
              <p className="mb-1 text-dark opacity-50 fw-semibold ps-3">
                Business Benefits:
              </p>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Passive TopCoin accumulation when other global users spend.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Inclusion in international TCUK promotions and campaigns.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Real-time analytics and customer engagement tracking.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                5. Customer Policy (Global Users)
              </h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Customers of all ages (including under 18) may participate and
                  hold TopCoin.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  No registration fees or purchases of TopCoins are allowed.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Customers can track their wallet progress via the TCUK App or
                  official partners.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoin cannot be exchanged for cash directly. Cash rewards
                  are discretionary loyalty benefits funded by TopCoin UK
                  promotional budgets and are not financial investments, savings
                  products, or guaranteed payments.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">6. Legal and Compliance</h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TCUK operates under UK jurisdiction and may expand globally
                  through licensing and affiliate partnerships.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Each country where TCUK operates must comply with its own
                  consumer protection, advertising, and data-privacy
                  regulations.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TCUK is not regulated by the Financial Conduct Authority (FCA)
                  because it does not operate as a financial product, investment
                  scheme, banking service, cryptocurrency, or security.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All TopCoin rewards are issued strictly as part of a customer
                  loyalty and rewards programme, not as financial returns,
                  interest, dividends, or investments.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All monetary rewards distributed through the system are
                  classified as loyalty-based rewards only, linked to
                  participation and engagement within the TCUK ecosystem.
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75 ">
                7. Fraud Prevention & Abuse
              </h6>
              <p className="mb-1 text-dark opacity-50 fw-semibold ps-3">
                TCUK reserves the right to suspend or permanently close any
                account involved in:
              </p>
              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Any attempt to manipulate, artificially increase, or misuse
                  TopCoin rewards
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Any fraudulent activity relating to the business pa
                </li>

                {/*  <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Misrepresentation of the TCUK system
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Regular audits and blockchain integrity checks ensure
                  transparent and fair distribution.
                </li> */}
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                8. Brand & Global Identity
              </h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All regional offices and partners must use approved TCUK
                  branding, logos, messaging, and promotional materials.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Any localisation must be approved by TCUK to ensure
                  consistency and compliance.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  The phrase “TopCoin UK – Earn While You Spend” (or approved
                  equivalent wording) must remain clearly represented in global
                  communications.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All international growth and expansion must remain aligned
                  with TCUK system principles, transparency standards, and
                  loyalty-based reward objectives.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  <li
                    data-aos="fade-up"
                    data-aos-duration="600"
                    data-aos-delay="100"
                  >
                    All international growth and expansion must remain aligned
                    with TCUK system principles, transparency standards, and
                    loyalty-based reward objectives.
                  </li>
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">
                9. Global Wallet Progression Standard (7 Levels)
              </h6>

              <ul className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Bronze Cash wallet 1 opens at 20,000 TopCoin
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Nickel cash wallet 2 opens at 200,000 TopCoin
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 2 £100 TopCoin Cash Wallet 1 (£) */}
                  Titanium cash wallet 3 opens at 2,000,000 TopCoin
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 3 £1,000 TopCoin Cash Wallet 2 (£) */}
                  Silver cash wallet 4 opens at 4,000,000 TopCoin
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 4 £10,000 TopCoin Cash Wallet 3 (£) */}
                  Palladium cash wallet 5 opens at 8,000,000 TopCoin
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 5 £50,000 TopCoin Cash Wallet 4 (£) */}
                  Platinum cash wallet 6 opens at 12,000,000TopCoin
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 6 £100,000 TopCoin Cash Wallet 5 (£) */}
                  Lirdium cash wallet 7 opens at 16,000,000 TopCoin
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 6 £100,000 TopCoin Cash Wallet 5 (£) */}
                  Gold cash wallet 8 opens at 20,000,000 TopCoin
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  {/* TopCoin Wallet 6 £100,000 TopCoin Cash Wallet 5 (£) */}
                  Eternity cash wallet 9 opens at 30,000,000 TopCoin
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-dark opacity-75">10. Final Notes</h6>

              <ol className="text-dark opacity-50">
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoin UK is designed to scale globally, support customers,
                  and help businesses benefit from smarter loyalty and
                  advertising solutions.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  All international operations and expansions are managed under
                  TopCoin UK Ltd governance to ensure consistency and compliance
                  with local regulations.
                </li>

                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  Any disputes related to the use of this loyalty system are
                  handled under the laws of the customer or business’s local
                  jurisdiction, with UK HQ available to support arbitration
                  where required.
                </li>
                <li
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="100"
                >
                  TopCoin UK does not provide financial services, investment
                  opportunities, banking services, cryptocurrency trading, or
                  regulated financial products. All rewards are loyalty-based
                  only.
                </li>
              </ol>
            </div>
            {/* <p className="text-dark opacity-50">
              This policy is designed to protect the value of the TopCoin UK
              system and ensure that active, engaged users benefit from its full
              rewards — including access to cash wallets and long-term earnings.
            </p>
            <p className="text-dark opacity-50">
              We thank you for your understanding and commitment to the future
              of TopCoin UK.
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopCoinUkPolicy;
